import { Collection } from 'firestorter';

import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

const CoachIdentityStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

class CoachIdentity extends BaseDocument {
  constructor(id, opts) {
    super(`${CollectionName.COACH_IDENTITY}/${id}`, opts);
  }

  get coachIdentityPrompt() {
    return this.data?.coachIdentityPrompt;
  }

  get status() {
    return this.data?.status;
  }

  get coachId() {
    return this.data?.coachId;
  }

  get instagramUserId() {
    return this.data?.instagramUserId;
  }

  get checkInStylePrompt() {
    return this.data?.checkInStylePrompt;
  }

  get smartContextStylePrompt() {
    return this.data?.smartContextStylePrompt;
  }

  static async getCoachIdentity(coachId) {
    const coachIdentity = new CoachIdentity(coachId);
    await coachIdentity.init();
    return coachIdentity.exists ? coachIdentity : null;
  }

  static async getDefaultCoachIdentity() {
    const coachIdentityCollection = new Collection(CollectionName.COACH_IDENTITY, {
      createDocument: (source, options) => new CoachIdentity(source.id, options),
      query: (ref) => ref
        .where('isDefault', '==', true)
        .limit(1),
    });
    await coachIdentityCollection.fetch();
    return coachIdentityCollection.hasDocs ? coachIdentityCollection.docs[0] : null;
  }
}

export default CoachIdentity;

export { CoachIdentityStatus };
